import { EventBus } from "../../../eventbus";

import { baseUrl } from "../../../config.js";
import i18n from "../../../functions/i18next";

export default {
  props: ["selectedSpace", "mode"],

  /*
      Defines the data used by the component
    */
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      show: false,
      successend: false,
      name: "",
      description: "",
      color: "CCC",
      isprivate: 0,
      errors: [],
      make_private: 0,
      make_private_public: 0,
      isUploading: false,
      descMax: 100,
    };
  },
  created() {
    this.$axios
      .get(baseUrl + "/folderdetail?folder=" + this.selectedSpace, {
        responseType: "json",
      })
      .then((response) => {
        this.name = response.data.name;
        if (response.data.description) {
          this.description = response.data.description;
        }
        this.color = response.data.color;

        this.isprivate = response.data.private;

        if (this.user.rights.edit_spaces === 1) {
          this.$nextTick(() => {
            //this.$refs.name.focus();
          });
        }
      });
  },
  methods: {
    editSpace() {
      this.isUploading = true;

      let formData = new FormData(this.$refs.editSpace);
      this.errors = [];

      formData.append("foldertoupdate", this.selectedSpace);
      formData.append("private", 1);

      this.$axios
        .post(baseUrl + "/folderupdate", formData)
        .then((response) => {
          if (response.data.success) {
            this.successend = true;
            EventBus.$emit("spaceadded", "list");
          } else {
            this.successend = false;
            if (response.data.msg == "duplicate") {
              this.errors.push(i18n.t("spaces.space_exists"));
            }
          }
        })
        .catch((response) => {
          this.isUploading = false;
        });
    },
  },
};
